import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import FileService from "services/fileService";
import LoadingImage from "../../assets/images/loading_image.gif";
import NoImageAvailable from "../../assets/images/no_image_available.png";

function LazyImage({ url }, props) {
    const [src, setSrc] = useState(LoadingImage);
    const imgRef = useRef();
    function loadCall() {
        FileService.loadFile(url)
            .then((data) => {
                const urlData = data || NoImageAvailable;
                if (imgRef.current) {
                    setSrc(urlData);
                }
            })
            .catch(() => {
                if (imgRef.current) {
                    setSrc(NoImageAvailable);
                }
            });
    }
    useEffect(() => {
        loadCall();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <img src={src} alt="" ref={imgRef} {...props} />;
}

LazyImage.propTypes = {
    url: PropTypes.string.isRequired,
};

export default LazyImage;
